import { ERoleType } from './chat';

export interface ILikeMemoryReq {
  memory_id: number;
  is_like: boolean;
}

export interface ILikeMemoryResp {
  like_count?: number;
}

export enum EFilterType {
  HOT = 1,
  NEW = 2,
  MINE = 3,
  WEB_SITEMAP = 4, // 传这个的话，memory只会给最小化的数据
  QUESTION = 5, // 问答页面
  UGC_MEMORY_SEO = 6, // for 服务端自身调用使用
  UGC_MEMORY_SEO_SITEMAP_SEO = 7, // for 前端使用。 精简数据（给 sitemap 使用）
  UGC_MEMORY_SEO_SITEMAP = 8, // for 前端使用。全量数据
  New_SITEMAP = 9, // 2数据的简化版本
}

export interface IPageQueryMemoriesReq {
  size?: number;
  max_create_time?: number;
  language?: string;
  filter_type?: number;
  offset?: number; // 从 0 开始
}

export interface IMemoryChatMessage {
  mid?: string; // 环信消息id
  cid?: string; // 环信会话id
  content?: string; // 消息内容
  sender_id?: number; // 发送者的id
  sender_role_type?: ERoleType; // 发送者的角色
  voice_url?: string; // 语音url
  voice_duration_ms?: number; // 语音时长
}

export interface IMemory {
  memory_id?: number;
  like_count?: number;
  title?: string;
  chat_msgs?: IMemoryChatMessage[];
  create_timestamp_ms?: number;
  liked?: boolean;
  memories_cnt?: number;
  visible_all?: boolean; // 是否所有人可见
  // 用户字段
  user_id?: number;
  user_name?: string;
  user_avatar?: string;
  // npc字段
  npc_id?: number;
  npc_name?: string;
  npc_avatar?: string;
  npc_background?: string;
  npc_avatar_small_thumbnail_img_url?: string;
  language?: string;
  parent_memory_id?: number; // 用于seo的memory,会有 parent momery概念
  sibling_language_memory_list?: IMemory[]; // 多语言的兄弟节点的memory_id. 只填充基础字段，如id、language、title
}

export interface IPageQueryMemoriesResp {
  memories?: IMemory[];
  has_more?: boolean;
}

export interface IDeleteMemoryReq {
  memory_id: number;
}

export interface IGetMemoryDetailReq {
  memory_id: number;
  scene?: number;
  need_multi_language?: boolean;
}

export interface IGetMemoryDetailResp {
  memory?: IMemory;
}
